// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer{background:#222;color:#fdfdfd;align-items:center;display:flex;flex-direction:column;justify-content:center;padding:24px;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
